import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import { router, http } from './http'
import store from './store'
import vuetify from './plugins/vuetify'
import "./plugins/toastification"
import VueCryptojs from 'vue-cryptojs'
import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import VueMixpanel from 'vue-mixpanel'
import 'pwacompat'

// Import ENV config
import config from './config'


// SENTRY IMPORTS 
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

// Import global scss
import '@/assets/Global/scss/global.scss'
import '@/assets/Global/scss/variables.scss'

//import layouts
import Private from './layouts/private.vue'
import Public from './layouts/public.vue'

Vue.component('private-layout', Private)
Vue.component('public-layout', Public)
Vue.use(Datetime)
Vue.use(VueMixpanel, {
  token: "JHDVBASDHYWSAHDGVCHYAS",
  config: {
    debug: true
  }
})
Vue.config.productionTip = false;

Vue.use(http)
Vue.use(VueCryptojs)
Vue.use(require('vue-moment'));


// ============== GLOBAL MIXINS TO TOGGLE VIEW BASED ON USERS PERMISSION ===========
if(store.state.userDetails){
  const userPermissions = store.state.userDetails.permissions;
  Vue.mixin({
    methods: {
      can: (key) => userPermissions.includes(key) || !key
    }
  })
}
// ========= FUNCTION ENDS =========

Vue.http.defaults.headers.common[
	'Authorization'
] = `Bearer ${sessionStorage.getItem('authToken')}`

// SENTRY INITIALIZATION
Sentry.init({
  Vue,
  dsn: config.sentry.dsn,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "my-site-url.com", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

let app

app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

export default app